const Icon = icon => (`
    <svg class="icon icon-${icon}">
        <use
            href="/assets/svg/sprite.symbol.svg#${icon}"
            xlink:href="/assets/svg/sprite.symbol.svg#${icon}"
        />
    </svg>
`);

export default Icon;
